import './EmptyLayout.scss';
import { ReactNode } from 'react';
import clsx from 'clsx';

export interface IEmptyLayoutProps {
    /** Страница */
    children: ReactNode;
    /** Заголовок вкладки браузера */
    title?: string;
    /** Без декоративной подложки — на фоне документа */
    plain?: boolean;
}

/** Раскладка экранов без оболочки (вход, восстановление пароля): страница по центру на декоративной подложке. */
const EmptyLayout = ({ children, title, plain = false }: IEmptyLayoutProps) => (
    <>
        {title !== undefined && <title>{title}</title>}
        <div className={clsx('content-center layout-empty', plain && 'layout-empty--plain')}>{children}</div>
    </>
);

export default EmptyLayout;
